function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
}
else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FaLinode, FaMicrochip, FaSortAmountUp, FaUserAlt } from 'react-icons/fa';
import { routes } from '../../router/routes';
import { HiDocumentReport } from 'react-icons/hi';
import { AiOutlineAreaChart, AiOutlineCalculator } from 'react-icons/ai';
import { MdPeopleAlt, MdOutlineAccountBalanceWallet, MdOutlineSummarize } from 'react-icons/md';
import { BsReverseLayoutTextSidebarReverse, BsBarChart } from 'react-icons/bs';
import { IoMdStats } from 'react-icons/io';
import { GiPingPongBat, GiProfit, GiCardExchange, GiHealthIncrease, GiAerialSignal } from 'react-icons/gi';
import { FiUsers } from 'react-icons/fi';
import { RiMastercardLine } from 'react-icons/ri';
import { VscSettingsGear } from 'react-icons/vsc';
import { EnumReportTypes } from '../../constants/EnumReportTypes';
import { getCurrentUser } from '../AuthUser/actions';
import { connect } from 'react-redux';
import { ROUTE_ACCESSES } from '../../constants/ROUTE_ACCESSES';
import RoleAccessMiddleware from '../Middleware/RouteAccessMiddleware';
import SubMenuTitle from './SubMenuTitle';
import './styles.scss';
import SubMenuItem from './SubMenuItem';
import RouteAccessMiddleware from '../Middleware/RouteAccessMiddleware';
import { TbLayoutDashboard } from 'react-icons/tb';
import StringHelper from '../../helpers/StringHelper';
var Menu = /*#__PURE__*/ function (_Component) {
    _inherits(Menu, _Component);
    var _super = _createSuper(Menu);
    function Menu(props) {
        var _this;
        _classCallCheck(this, Menu);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "algorithmNameLength", 17);
        _defineProperty(_assertThisInitialized(_this), "isOpenMenuOnPath", function (path) {
            return _this.props.match.path.split('/')[1] === path.split('/')[1];
        });
        _defineProperty(_assertThisInitialized(_this), "isOpenDashboardMenu", function () {
            return (_this.isOpenMenuOnPath(routes.DASHBOARD_LIST) || _this.isOpenMenuOnPath(routes.POSITION_LIST)) && !_this.state.isOpenDashboard;
        });
        _defineProperty(_assertThisInitialized(_this), "handleToggleAlgorithms", function () {
            _this.setState(function (prev) {
                return {
                    isOpenAlgorithms: !prev.isOpenAlgorithms
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleToggleReports", function () {
            _this.setState(function (prev) {
                return {
                    isOpenReports: !prev.isOpenReports
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleToggleDashboard", function () {
            _this.setState(function (prev) {
                return {
                    isOpenDashboard: !prev.isOpenDashboard
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "getRootOfPath", function (path) {
            return "/".concat(path.split('/')[1]);
        });
        _defineProperty(_assertThisInitialized(_this), "isActive", function (menu) {
            var _this$props$match$par;
            var path = _this.getRootOfPath(_this.props.match.path);
            if ((_this$props$match$par = _this.props.match.params) !== null && _this$props$match$par !== void 0 && _this$props$match$par.name) {
                return _this.props.match.params.name === menu ? 'active' : '';
            }
            if (path === _this.getRootOfPath(routes.REPORTS)) {
                return _this.props.match.params.id === menu ? 'active' : '';
            }
            return path === menu ? 'active' : '';
        });
        _defineProperty(_assertThisInitialized(_this), "isOpenSubMenu", function (isOpen) {
            return isOpen ? 'menu-is-opening menu-open' : '';
        });
        _this.state = {
            reportTypes: [],
            isOpenAlgorithms: _this.props.match.path.split('/')[1] === routes.ALGORITHM.split('/')[1],
            isOpenReports: false,
            isOpenDashboard: false,
            closedMenu: false
        };
        return _this;
    }
    _createClass(Menu, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.setState({
                    closedMenu: true
                });
                setTimeout(function () {
                    _this2.setState({
                        closedMenu: false
                    });
                }, 1000);
                if (this.isOpenMenuOnPath(routes.ALGORITHM) && !this.state.isOpenAlgorithms) {
                    this.setState({
                        isOpenAlgorithms: true
                    });
                }
                if (this.isOpenMenuOnPath(routes.REPORTS) && !this.state.isOpenReports) {
                    this.setState({
                        isOpenReports: true
                    });
                }
                if (this.isOpenDashboardMenu()) {
                    this.setState({
                        isOpenDashboard: true
                    });
                }
            }
        }, {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ React.createElement("aside", {
                    className: "main-sidebar hover-main-sidebar sidebar-dark-primary elevation-4 ".concat(this.props.isMenuOpened === false ? !this.state.closedMenu ? 'sidebar-closed' : 'sidebar-closed-no-hover' : 'sidebar-opened', " sideBar")
                }, /*#__PURE__*/ React.createElement("a", {
                    href: "http://adminka.crypto.loc/dashboard",
                    className: 'brand-link'
                }, /*#__PURE__*/ React.createElement("span", null, process.env.REACT_APP_NAME)), /*#__PURE__*/ React.createElement("div", {
                    className: "sidebar"
                }, /*#__PURE__*/ React.createElement("nav", {
                    className: "mt-2"
                }, /*#__PURE__*/ React.createElement("ul", {
                    className: "nav nav-pills nav-sidebar flex-column",
                    "data-widget": "treeview",
                    role: "menu"
                }, /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.users.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.USER_LIST),
                    to: routes.USER_LIST,
                    id: "test-users-menu-item"
                }, /*#__PURE__*/ React.createElement(MdPeopleAlt, null), " ", /*#__PURE__*/ React.createElement("p", null, " Users ")))), /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.brokers.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.BROKER_LIST),
                    to: routes.BROKER_LIST,
                    id: "test-brokers-menu-item"
                }, /*#__PURE__*/ React.createElement(AiOutlineAreaChart, null), " ", /*#__PURE__*/ React.createElement("p", null, " Brokers ")))), /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.pairs.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.PAIR_LIST),
                    to: routes.PAIR_LIST,
                    id: "test-pairs-menu-item"
                }, /*#__PURE__*/ React.createElement(FaLinode, null), " ", /*#__PURE__*/ React.createElement("p", null, " Pairs ")))), /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.accounts.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.ACCOUNTS),
                    to: routes.ACCOUNTS,
                    id: "test-accounts-menu-item"
                }, /*#__PURE__*/ React.createElement(FaUserAlt, null), " ", /*#__PURE__*/ React.createElement("p", null, " Accounts ")))), /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.balanceCurrency.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.BALANCE_CURRENCY_LIST),
                    to: routes.BALANCE_CURRENCY_LIST,
                    id: "test-balance-currency-menu-item"
                }, /*#__PURE__*/ React.createElement(BsReverseLayoutTextSidebarReverse, null), " ", /*#__PURE__*/ React.createElement("p", null, " Balance currency ")))), /*#__PURE__*/ React.createElement(RoleAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.clients.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.CLIENTS),
                    to: routes.CLIENTS,
                    id: "test-clients-menu-item"
                }, /*#__PURE__*/ React.createElement(FiUsers, null), /*#__PURE__*/ React.createElement("p", null, " Clients")))), /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item "
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.PROCESSES),
                    to: routes.PROCESSES,
                    id: "test-processes-menu-item"
                }, /*#__PURE__*/ React.createElement(FaMicrochip, null), /*#__PURE__*/ React.createElement("p", null, " Processes "))), /*#__PURE__*/ React.createElement("li", {
                    className: 'nav-item' + ' ' + this.isOpenSubMenu(this.state.isOpenAlgorithms)
                }, /*#__PURE__*/ React.createElement(SubMenuTitle, {
                    className: this.props.match.path.includes('algorithms') ? 'active opacity-100' : '',
                    isOpen: this.state.isOpenAlgorithms,
                    handleToggleOpen: this.handleToggleAlgorithms
                }, /*#__PURE__*/ React.createElement(IoMdStats, null), ' ', /*#__PURE__*/ React.createElement("p", null, "Algorithms")), /*#__PURE__*/ React.createElement("ul", {
                    className: "nav nav-treeview ".concat(this.state.isOpenAlgorithms ? 'sub-menu-animated' : 'sub-menu')
                }, /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.algorithms.liquidityMaker.index
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-LiquidityMaker",
                    to: routes.ALGORITHM.replace(':name', 'LiquidityMaker'),
                    isActive: this.isActive('LiquidityMaker')
                }, /*#__PURE__*/ React.createElement(GiProfit, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", {
                    className: "mb-0"
                }, "LiquidityMaker"))), /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.algorithms.dexArbitrage.index
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-DexArbitrage",
                    to: routes.ALGORITHM.replace(':name', 'DexArbitrage'),
                    isActive: this.isActive('DexArbitrage')
                }, /*#__PURE__*/ React.createElement(RiMastercardLine, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "DexArbitrage"))), /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.algorithms.pingPong.index
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-PingPong",
                    to: routes.ALGORITHM.replace(':name', 'PingPong'),
                    isActive: this.isActive('PingPong')
                }, /*#__PURE__*/ React.createElement(GiPingPongBat, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "PingPong"))), /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.algorithms.volumeMaker.index
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-VolumeMaker",
                    to: routes.ALGORITHM.replace(':name', 'VolumeMaker'),
                    isActive: this.isActive('VolumeMaker')
                }, /*#__PURE__*/ React.createElement(FaSortAmountUp, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "VolumeMaker"))), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-Lvp",
                    to: routes.ALGORITHM.replace(':name', 'LPV'),
                    isActive: this.isActive('LPV')
                }, /*#__PURE__*/ React.createElement(GiPingPongBat, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "LPV")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-VolumeIncreaseLiquidityMaker",
                    to: routes.ALGORITHM.replace(':name', 'VolumeIncreaseLiquidityMaker'),
                    isActive: this.isActive('VolumeIncreaseLiquidityMaker')
                }, /*#__PURE__*/ React.createElement(GiHealthIncrease, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", {
                    className: "mb-0",
                    title: "VolumeIncreaseLiquidityMaker"
                }, StringHelper.cutString('VolumeIncreaseLiquidityMaker', this.algorithmNameLength))), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "menu-item-Lvp",
                    to: routes.ALGORITHM.replace(':name', 'ESignal'),
                    isActive: this.isActive('ESignal')
                }, /*#__PURE__*/ React.createElement(GiAerialSignal, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "ESignal")))), /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.SETTINGS),
                    to: routes.SETTINGS,
                    id: "test-settings-menu-item"
                }, /*#__PURE__*/ React.createElement(VscSettingsGear, null), " ", /*#__PURE__*/ React.createElement("p", null, "Settings"))), /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
                    routeRequest: ROUTE_ACCESSES.reports.index
                }, /*#__PURE__*/ React.createElement("li", {
                    className: 'nav-item' + ' ' + this.isOpenSubMenu(this.state.isOpenReports)
                }, /*#__PURE__*/ React.createElement(SubMenuTitle, {
                    isOpen: this.state.isOpenReports,
                    handleToggleOpen: this.handleToggleReports,
                    className: this.props.match.path.includes('reports') ? 'active opacity-100' : ''
                }, /*#__PURE__*/ React.createElement(HiDocumentReport, null), ' ', /*#__PURE__*/ React.createElement("p", null, "Reports")), /*#__PURE__*/ React.createElement("ul", {
                    className: "nav nav-treeview ".concat(this.state.isOpenReports ? 'sub-menu-animated sub-menu-open' : 'sub-menu')
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "AccountBalancesReport",
                    to: routes.REPORTS_TEMPLATES.replace(':id', String(EnumReportTypes.AccountBalancesReport)),
                    isActive: this.isActive(String(EnumReportTypes.AccountBalancesReport))
                }, /*#__PURE__*/ React.createElement(MdOutlineAccountBalanceWallet, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Account balance")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "SummaryReport",
                    to: routes.REPORTS_TEMPLATE.replace(':id', String(EnumReportTypes.SummaryReport)),
                    isActive: this.isActive(String(EnumReportTypes.SummaryReport))
                }, /*#__PURE__*/ React.createElement(MdOutlineSummarize, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Summary")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "DiagramReport",
                    to: routes.REPORTS_TEMPLATE.replace(':id', String(EnumReportTypes.DiagramReport)),
                    isActive: this.isActive(String(EnumReportTypes.DiagramReport))
                }, /*#__PURE__*/ React.createElement(BsBarChart, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Diagram")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "ExchangeVolumeReport",
                    to: routes.REPORTS_TEMPLATES.replace(':id', String(EnumReportTypes.ExchangeVolumeReport)),
                    isActive: this.isActive(String(EnumReportTypes.ExchangeVolumeReport))
                }, /*#__PURE__*/ React.createElement(GiCardExchange, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Exchange Volume"))))), /*#__PURE__*/ React.createElement("li", {
                    className: 'nav-item' + ' ' + this.isOpenSubMenu(this.state.isOpenDashboard)
                }, /*#__PURE__*/ React.createElement(SubMenuTitle, {
                    isOpen: this.state.isOpenDashboard,
                    handleToggleOpen: this.handleToggleDashboard,
                    className: this.props.match.path.includes('dashboard') ? 'active opacity-100' : '' || this.props.match.path === '/algorithm' ? 'active opacity-100' : '' || this.props.match.path.includes('position') ? 'active opacity-100' : ''
                }, /*#__PURE__*/ React.createElement(HiDocumentReport, {
                    className: "mr-1"
                }), /*#__PURE__*/ React.createElement("p", null, "Dashboard")), /*#__PURE__*/ React.createElement("ul", {
                    className: "nav nav-treeview ".concat(this.state.isOpenDashboard ? 'sub-menu-animated sub-menu-open' : 'sub-menu')
                }, /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "Dashboard",
                    to: routes.DASHBOARD_LIST,
                    isActive: this.isActive(routes.DASHBOARD_LIST)
                }, /*#__PURE__*/ React.createElement(TbLayoutDashboard, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Dashboard")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "Position",
                    to: routes.POSITION_LIST,
                    isActive: this.isActive(routes.POSITION_LIST)
                }, /*#__PURE__*/ React.createElement(MdOutlineSummarize, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Position")), /*#__PURE__*/ React.createElement(SubMenuItem, {
                    name: "Algorithm",
                    to: routes.ALGORITHM_LIST,
                    isActive: this.isActive(routes.ALGORITHM_LIST)
                }, /*#__PURE__*/ React.createElement(MdOutlineSummarize, {
                    className: "mr-2"
                }), /*#__PURE__*/ React.createElement("p", null, "Algorithm")))), /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item"
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.RISK),
                    to: routes.RISK
                }, /*#__PURE__*/ React.createElement(AiOutlineCalculator, {
                    className: "mr-1"
                }), /*#__PURE__*/ React.createElement("p", null, "Risk"))), /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item "
                }, /*#__PURE__*/ React.createElement(Link, {
                    className: 'nav-link ' + this.isActive(routes.LOGS),
                    to: routes.LOGS
                }, /*#__PURE__*/ React.createElement(BsReverseLayoutTextSidebarReverse, null), /*#__PURE__*/ React.createElement("p", null, " Logs ")))))));
            }
        }]);
    return Menu;
}(Component);
var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.authUser.authUser
    };
};
var mapDispatchToProps = {
    getCurrentUser: getCurrentUser
};
export default connect(mapStateToProps, mapDispatchToProps)(Menu);
